module.exports = __webpack_public_path__ + "img/point-free-1.7384f49a.png";